// ImageSelector.js
import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import axios from 'axios';
import { Hearts } from 'react-loader-spinner';

export const ImageSelector = ({ onImageSelect, selectedImage }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [unsplashImages, setUnsplashImages] = useState([]);
    const [searching, setSearching] = useState(false);
    const [previewImage, setPreviewImage] = useState(selectedImage || '');
    const fileInputRef = useRef(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            setPreviewImage(e.target.result);
            onImageSelect(e.target.result);
        };
        reader.readAsDataURL(file);
    };

    const searchUnsplash = async () => {
        if (!searchQuery.trim()) return;

        try {
            setSearching(true);
            // You would need to set up a backend endpoint that interfaces with Unsplash API
            const response = await axios.get(`https://api.frazza.online/api/unsplash?query=${searchQuery}`);
            setUnsplashImages(response.data.results || []);
        } catch (error) {
            console.error('Error searching Unsplash:', error);
        } finally {
            setSearching(false);
        }
    };

    const selectUnsplashImage = (image) => {
        setPreviewImage(image.urls.regular);
        onImageSelect(image.urls.regular);
    };

    return (
        <div className="image-selector">
            {previewImage && (
                <div className="preview-container">
                    <img src={previewImage} alt="Preview" className="image-preview" />
                    <Button
                        icon="pi pi-times"
                        className="remove-image-btn"
                        onClick={() => {
                            setPreviewImage('');
                            onImageSelect('');
                        }}
                    />
                </div>
            )}

            <div className="unsplash-search">
                <div className="search-field">
                    <InputText
                        value={searchQuery}
                        className="crf-input-full"
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search for food images..."
                        onKeyDown={(e) => e.key === 'Enter' && searchUnsplash()}
                    />
                    <Button
                        icon="pi pi-search"
                        onClick={searchUnsplash}
                        loading={searching}
                    />
                </div>

                <div className="unsplash-results">
                    {searching ? (
                        <div className="searching-state">
                            <Hearts height="60" width="60" color="#f97316" ariaLabel="hearts-loading" visible={true} />
                            <p>Searching Unsplash...</p>
                        </div>
                    ) : unsplashImages.length > 0 ? (
                        <div className="image-grid">
                            {unsplashImages.map((image) => (
                                <div
                                    key={image.id}
                                    className="image-item"
                                    onClick={() => selectUnsplashImage(image)}
                                >
                                    <img src={image.urls.small} alt={image.alt_description} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="empty-search">
                            <p>Search for delicious food images on Unsplash</p>
                        </div>
                    )}
                </div>

                <div className="unsplash-attribution">
                    <small>Photos from <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer">Unsplash</a></small>
                </div>
            </div>

            {/* <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                <TabPanel header="Upload Image">
                    <div className="upload-area">
                        <div
                            className={`dropzone ${previewImage ? 'has-image' : ''}`}
                            onClick={() => fileInputRef.current.click()}
                        >
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                accept="image/*"
                                onChange={handleFileUpload}
                            />
                            {!previewImage && (
                                <>
                                    <i className="pi pi-cloud-upload upload-icon"></i>
                                    <p>Click to browse or drop an image here</p>
                                    <small>Supports JPG, PNG, GIF (max 5MB)</small>
                                </>
                            )}
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header="Search Unsplash">
                    <div className="unsplash-search">
                        <div className="search-field">
                            <InputText
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search for food images..."
                                onKeyDown={(e) => e.key === 'Enter' && searchUnsplash()}
                            />
                            <Button
                                icon="pi pi-search"
                                onClick={searchUnsplash}
                                loading={searching}
                            />
                        </div>

                        <div className="unsplash-results">
                            {searching ? (
                                <div className="searching-state">
                                    <i className="pi pi-spin pi-spinner"></i>
                                    <p>Searching Unsplash...</p>
                                </div>
                            ) : unsplashImages.length > 0 ? (
                                <div className="image-grid">
                                    {unsplashImages.map((image) => (
                                        <div
                                            key={image.id}
                                            className="image-item"
                                            onClick={() => selectUnsplashImage(image)}
                                        >
                                            <img src={image.urls.small} alt={image.alt_description} />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="empty-search">
                                    <p>Search for delicious food images on Unsplash</p>
                                </div>
                            )}
                        </div>

                        <div className="unsplash-attribution">
                            <small>Photos from <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer">Unsplash</a></small>
                        </div>
                    </div>
                </TabPanel>
            </TabView>*/}
        </div>
    );
};

export default ImageSelector;
